import PropTypes from 'prop-types';
import React from 'react';

import { contentfulViews } from '@glowforge/ui-common';

const { TextSection } = contentfulViews;

const ReferralConfirmation = props => (
  <div className='ReferralPaymentPage contentPage'>
    <TextSection
      {...props.confirmationPageContent}
      headerClass='h1'
      className='content' />
  </div>
);

ReferralConfirmation.propTypes = {
  confirmationPageContent: PropTypes.shape(TextSection.propTypes).isRequired,
};

export default ReferralConfirmation;



// WEBPACK FOOTER //
// ./app/components/support/referral/confirmation.jsx